import type { FormField } from '@/forms/typings';
import { FormValidation } from '@/forms/typings';

/**
 * Returns the fieldId suffix (after `${instanceFieldId}_`) for each direct
 * child that carries a Required validation rule.
 */
export const getRequiredChildSuffixes = (
  instanceFieldId: string,
  children: FormField[],
): string[] => {
  const prefix = `${instanceFieldId}_`;
  const suffixes: string[] = [];

  for (const child of children) {
    const validations = 'validations' in child
      ? (child as { validations?: Array<{ type: string }> }).validations
      : undefined;

    const isRequired = validations?.some(v => v.type === FormValidation.Required) ?? false;

    if (isRequired && child.fieldId.startsWith(prefix)) {
      suffixes.push(child.fieldId.slice(prefix.length));
    }
  }

  return suffixes;
};
